if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;
	if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
		linkTag.crossOrigin = "anonymous";
	}
	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"front-office_app": 0,
	"front-office_libs": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"front-office-components":1,"micro-app":1,"widget-comments-block-comments":1,"packages_widget-legacy_widget-legacy-post-list_components_LegacyContributionField_LegacyContr-3f3656":1,"lumx-spotlight":1,"tutorials-details":1,"gdpr-banner":1,"mobile-app-modal":1,"community-navigation":1,"social-advocacy-dashboard":1,"terms-and-conditions-modal":1,"lumdrian-platform":1,"widget-play":1,"uploading-corporate-video-form-dialog":1,"widget-playlist":1,"widget-recommended-training-courses":1,"widget-training-courses-in-progress":1,"widget-learning-catalog":1,"widget-user-kpi":1,"widget-team-kpi":1,"micro-app-picker-dialog":1,"micro-app-dialog":1,"file-list-lumapps-component":1,"file-list-lumapps-component-settings":1,"upload-media-lumapps-component":1,"widget-micro-app":1,"widget-learning-leaderboard":1,"widget-learning-certificate":1,"widget-article-list-block-article-preview":1,"block-community-preview":1,"block-page-preview":1,"block-structured-content":1,"widget-event-list-block-event-preview":1,"block-event-metadata":1,"block-personal-feed-preview":1,"block-play-video":1,"block-play-video-playlist":1,"widget-post-list-block-post":1,"block-learning-preview":1,"widget-remote-block-remote":1,"block-stream-item":1,"block-training":1,"block-augmented-container":1,"widget-breadcrumb":1,"widget-calendar":1,"widget-comments-block-comments-v2":1,"widget-content-filter":1,"widget-file-list":1,"widget-iframe":1,"widget-links":1,"widget-mandatory-read":1,"widget-metadata-selection":1,"widget-pdf-preview":1,"widget-share":1,"widget-sub-navigation":1,"widget-survey":1,"widget-video":1,"widget-base-block-reactions":1,"block-tab-filtered-container":1,"upload-image-dialog":1,"share-to-extension-dialog":1,"share-to-slack-dialog":1,"share-content-to-social-network-dialog":1,"share-to-teams-dialog":1,"responsive-main-side-navigation":1,"community-picker-dialog":1,"event-notification-dialog":1,"post-dialog":1,"space-creation-dialog":1,"post-analytics-dialog":1,"reports":1,"advanced-debug-info":1,"distribute-resource-dialog":1,"community-configuration-dialog":1,"insert-generative-content-dialog":1,"content-picker-dialog":1,"posts-picker":1,"upload-employee-video-dialog":1,"emoji-picker":1,"add-to-navigation-dialog":1,"space-navigation":1,"article-dialog":1,"event-dialog":1,"assistant-main-window":1,"content-widgets-translation-dialog":1,"adaptive-card":1,"block-contribution-field":1,"community-navigation-admin":1,"user-picker-dialog":1,"lazy-playlist":1,"shared-with-dialog":1,"lumx-calendar":1,"comment-editor-block":1,"widget-metadata-block-metadata":1,"generative-images-dialog":1,"space-navigation-admin":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr